import React, { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';

import { BreadcrumbItem } from 'types';
import { NavigationRightTools } from 'shared/components/layout/navigationRightTools/NavigationRightTools';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { LayoutTitle } from './LayoutTitle';
import { ReactComponent as PuppySpotLogo } from './puppyspot.svg';
import {
  BreadcrumbStyled,
  ContentStyled,
  HeaderStyled,
  LayoutStyled,
  LogoWrapper,
  SectionStyled,
} from './Layout.styles';

export type LayoutProps = {
  children: ReactElement[] | ReactElement | ReactNode;
  navigationCenterTools?: ReactElement[] | ReactElement | ReactNode;
  padding?: string;
};

export const Layout = (props: LayoutProps): ReactElement => {
  const { children, navigationCenterTools, padding } = props;
  const {
    state: { breadcrumbs },
  } = useLayoutState();

  return (
    <LayoutStyled padding={padding}>
      <HeaderStyled>
        <LogoWrapper>
          <PuppySpotLogo />
          <LayoutTitle />
        </LogoWrapper>
        {navigationCenterTools}
        <NavigationRightTools />
      </HeaderStyled>
      <ContentStyled>
        {breadcrumbs && (
          <BreadcrumbStyled>
            {breadcrumbs.map((b: BreadcrumbItem) => {
              return (
                <Breadcrumb.Item key={b.key}>
                  {b.path ? <Link to={b.path}>{b.label}</Link> : b.label}
                </Breadcrumb.Item>
              );
            })}
          </BreadcrumbStyled>
        )}
        <SectionStyled>{children}</SectionStyled>
      </ContentStyled>
    </LayoutStyled>
  );
};
